import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const Clock = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG height={16} width={16} viewBox={'0 0 512 512'} {...props}>
    <Path d='M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z' />
  </SVG>
);

export const ClockOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='16' height='16' viewBox='0 0 17 16' fill='none' {...props}>
    <Path
      d='M7.75 3.75C7.75 3.34375 8.0625 3 8.5 3C8.90625 3 9.25 3.34375 9.25 3.75V7.625L11.9062 9.375C12.25 9.625 12.3438 10.0938 12.0938 10.4375C11.875 10.7812 11.4062 10.875 11.0625 10.625L8.0625 8.625C7.875 8.5 7.75 8.25 7.75 8V3.75ZM8.5 0C12.9062 0 16.5 3.59375 16.5 8C16.5 12.4375 12.9062 16 8.5 16C4.0625 16 0.5 12.4375 0.5 8C0.5 3.59375 4.0625 0 8.5 0ZM2 8C2 11.5938 4.90625 14.5 8.5 14.5C12.0625 14.5 15 11.5938 15 8C15 4.4375 12.0625 1.5 8.5 1.5C4.90625 1.5 2 4.4375 2 8Z'
      fill='#383838'
    />
  </SVG>
);
